<section class="section section--type-{{ type }} {{ zIndex ? 'section--z-index-' + zIndex : '' }}" [ngClass]="{ 'section--top': top, 'section--bottom': bottom }">
  <div class="section__main section__main--gap-{{ gap }}">
    <ng-content></ng-content>
  </div>
</section>
